"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var FormItem_1 = __importDefault(require("../FormItem"));
function Select(_a) {
    var value = _a.value, options = _a.options, antd = _a.antd, error = _a.error, restProps = __rest(_a, ["value", "options", "antd", "error"]);
    react_1.useEffect(function () {
        var fixAutocomplete = function () {
            document
                .querySelectorAll(".ant-select-selection-search-input")
                .forEach(function (e) {
                e.setAttribute("autocomplete", "none");
            });
        };
        fixAutocomplete();
    }, []);
    return (react_1.default.createElement(FormItem_1.default, { antd: antd, error: error },
        react_1.default.createElement(antd_1.Select, __assign({ value: value || undefined }, restProps, { optionLabelProp: "label" }), options.map(function (item) {
            var _a, _b;
            return (react_1.default.createElement(antd_1.Select.Option, { key: (_a = item.key) !== null && _a !== void 0 ? _a : item.value, value: item.value, label: item.label, disabled: item.disabled || false }, (_b = item.dropdownLabel) !== null && _b !== void 0 ? _b : item.label));
        }))));
}
exports.default = Select;
